/* Bordures en pixel plein (pas de 0.5px) : la colonne de noms (flexbox) et la grille des jours
   (CSS grid) sont deux mises en page indépendantes, et arrondissent les bordures en sous-pixel
   différemment l'une de l'autre — un 0.5px cause un dérapage progressif entre les deux d'une
   ligne à l'autre. */
export const BORDER = '1px solid #e5e3de';
export const BORDER_DARK = '1px solid #ddd';
export const cell = (extra = {}) => ({ boxSizing: 'border-box', ...extra });

// En zoom semaine/mois on n'affiche que les séparateurs de semaine (après dimanche) pour aérer
export const dayBorder = (day, timelineZoom) =>
  timelineZoom === 'jour' || day.d.getDay() === 0 ? BORDER : 'none';

// Largeur de la colonne des noms selon le regroupement.
export const nameColumnWidth = (timelineGroupBy) => (timelineGroupBy === 'proj' ? 250 : 180);

// Hauteurs des lignes d'en-tête.
export const MONTH_H = 26;
export const WEEK_H = 20;
export const dayHeaderHeight = (timelineZoom) =>
  timelineZoom === 'mois' ? 20 : timelineZoom === 'jour' ? 36 : 30;
export const DAY_ABBR = ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'];

export const dayGridStyle = (N, COL) => ({
  display: 'grid',
  gridTemplateColumns: `repeat(${N}, ${COL}px)`,
});
